<div class="ap">
  <!--
  <div *ngIf="showPanel" class="hidden-panel">&nbsp;</div>
-->
  <ng-container *ngIf="paymentData">
    <form #form [action]="paymentData.postUrl" method="post" target="paygate">
      <ng-container *ngFor="let item of paymentData.parameters | keyvalue">
        <input type="hidden" [name]="item.key" [value]="item.value" />
      </ng-container>
      <iframe #iframe class="ap__iframe" name="paygate" title="paygate"></iframe>
    </form>
  </ng-container>
</div>
